import { render, staticRenderFns } from "./GoogleLoginButtonComponent.vue?vue&type=template&id=54a5ea62&scoped=true&"
import script from "./GoogleLoginButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./GoogleLoginButtonComponent.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleLoginButtonComponent.vue?vue&type=style&index=0&id=54a5ea62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5ea62",
  null
  
)

export default component.exports